import React, { useState } from "react";
import { RelocateBayDialog } from "./layout/RelocateBayDialog";
import { Button, Menu, MenuItem } from "@material-ui/core";
import ExpandMoreOutlinedIcon from "@material-ui/icons/ExpandMoreOutlined";

export const BayMenu = ({
  bayNumber,
  handleDeleteBay,
  handleAddLevel,
  bayList,
  setBayList,
  classes,
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [relocateOpen, setRelocateOpen] = useState();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCreate = async () => {
    handleAddLevel(bayNumber);
    handleClose();
  };

  const handleDelete = async () => {
    handleClose();
    await handleDeleteBay(bayNumber);
  };

  const name = `Bay ${(bayNumber + 1 < 10 ? " 0" : " ") + (bayNumber + 1)}`;

  return (
    <>
      <div className={classes.menu}>
        <Button
          onClick={handleClick}
          color="secondary"
          endIcon={<ExpandMoreOutlinedIcon />}
        >
          {name}
        </Button>
        {
          <Menu
            id="bay-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <MenuItem onClick={handleCreate}>Add new Level</MenuItem>
            <MenuItem onClick={() => setRelocateOpen(true)}>
              Relocate inventories
            </MenuItem>
            {bayNumber > 0 && bayNumber === bayList.length - 1 && (
              <MenuItem onClick={handleDelete}>Delete bay</MenuItem>
            )}
          </Menu>
        }
      </div>
      {relocateOpen && (
        <RelocateBayDialog
          bayList={bayList}
          setBayList={setBayList}
          bayNumber={bayNumber}
          relocateOpen={relocateOpen}
          setRelocateOpen={setRelocateOpen}
          handleClose={handleClose}
          classes={classes}
        />
      )}
    </>
  );
};
